import React, {useState, useEffect} from 'react';
import {
    Upload,
    Button,
    message,
    Progress,
    Card,
    Typography,
    Space,
    Tag,
    Popconfirm,
    Table,
    Modal,
    Form,
    Input,
    DatePicker,
    Select,
    Divider,
    Spin,
    Switch,
    Badge,
    Drawer,
    Statistic,
    Tabs,
    Alert,
    Tooltip,
    Row,
    Col,
    Descriptions,
    List,
    Empty
} from 'antd';
import {
    UploadOutlined,
    InboxOutlined,
    CheckCircleOutlined,
    WarningOutlined,
    DeleteOutlined,
    DownloadOutlined,
    EditOutlined,
    FileSearchOutlined,
    ClockCircleOutlined,
    CloudUploadOutlined,
    SyncOutlined,
    InfoCircleOutlined,
    RocketOutlined,
    BarChartOutlined,
    HistoryOutlined,
    AppstoreOutlined,
    RollbackOutlined,
    PauseOutlined,
    PlayCircleOutlined,
    RadarChartOutlined
} from '@ant-design/icons';
import moment from 'moment';
import apiService from "../services/api";



const sampleDevices = [
    {
        id: 'device-001',
        name: '智能调色机-01',
        ipAddress: '192.168.1.101',
        deviceType: 'Intelligent Color Mixing Machine',
        currentVersion: 'v1.2.3',
        targetVersion: 'v1.3.0',
        upgradeStatus: 'upgrading',
        progress: 45,
        lastHeartbeat: '2023-05-15T14:30:22Z',
        lastUpgradeTime: '2023-04-10T09:15:33Z',
        errorMessage: ''
    },
    {
        id: 'device-002',
        name: '传感器模块-05',
        ipAddress: '192.168.1.102',
        deviceType: 'Sensor Module',
        currentVersion: 'v2.0.1',
        targetVersion: 'v2.1.0',
        upgradeStatus: 'pending',
        progress: 0,
        lastHeartbeat: '2023-05-15T14:28:45Z',
        lastUpgradeTime: '2023-05-01T11:22:10Z',
        errorMessage: ''
    },
    {
        id: 'device-003',
        name: '控制单元-主控',
        ipAddress: '192.168.1.103',
        deviceType: 'Controller Unit',
        currentVersion: 'v3.1.5',
        targetVersion: '',
        upgradeStatus: 'idle',
        progress: 0,
        lastHeartbeat: '2023-05-15T14:25:18Z',
        lastUpgradeTime: '2023-03-20T16:45:29Z',
        errorMessage: ''
    },
    {
        id: 'device-004',
        name: '智能调色机-02',
        ipAddress: '192.168.1.104',
        deviceType: 'Intelligent Color Mixing Machine',
        currentVersion: 'v1.1.8',
        targetVersion: 'v1.3.0',
        upgradeStatus: 'completed',
        progress: 100,
        lastHeartbeat: '2023-05-15T14:22:37Z',
        lastUpgradeTime: '2023-05-14T20:15:42Z',
        errorMessage: ''
    },
    {
        id: 'device-005',
        name: '传感器模块-12',
        ipAddress: '192.168.1.105',
        deviceType: 'Sensor Module',
        currentVersion: 'v2.0.1',
        targetVersion: 'v2.1.0',
        upgradeStatus: 'failed',
        progress: 78,
        lastHeartbeat: '2023-05-15T14:20:55Z',
        lastUpgradeTime: '2023-05-15T13:45:18Z',
        errorMessage: '网络中断导致升级失败'
    },
    {
        id: 'device-006',
        name: '备用控制单元',
        ipAddress: '192.168.1.106',
        deviceType: 'Controller Unit',
        currentVersion: 'v3.0.9',
        targetVersion: '',
        upgradeStatus: 'idle',
        progress: 0,
        lastHeartbeat: '2023-05-15T14:18:12Z',
        lastUpgradeTime: '2023-02-28T10:33:47Z',
        errorMessage: ''
    },
    {
        id: 'device-007',
        name: '智能调色机-03',
        ipAddress: '192.168.1.107',
        deviceType: 'Intelligent Color Mixing Machine',
        currentVersion: 'v1.2.3',
        targetVersion: '',
        upgradeStatus: 'idle',
        progress: 0,
        lastHeartbeat: '2023-05-15T14:15:29Z',
        lastUpgradeTime: '2023-04-05T08:12:56Z',
        errorMessage: ''
    },
    {
        id: 'device-008',
        name: '传感器模块-08',
        ipAddress: '192.168.1.108',
        deviceType: 'Sensor Module',
        currentVersion: 'v2.0.5',
        targetVersion: 'v2.1.0',
        upgradeStatus: 'upgrading',
        progress: 22,
        lastHeartbeat: '2023-05-15T14:12:43Z',
        lastUpgradeTime: '2023-04-25T14:28:19Z',
        errorMessage: ''
    }
];

const {Dragger} = Upload;
const {Title, Text} = Typography;
const {Option} = Select;
const {TextArea} = Input;
const {TabPane} = Tabs;

const FirmwareManagement = () => {
    // 固件上传和管理状态
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [firmwareList, setFirmwareList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentFirmware, setCurrentFirmware] = useState(null);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0,
        pageCount: 0
    });

    // 设备管理状态
    const [activeTab, setActiveTab] = useState('list');
    // const [devices, setDevices] = useState(sampleDevices.map(device => ({
    //     ...device,
    //     key: device.id
    // })));
    const [devices, setDevices] = useState([]);
    const [devicePagination, setDevicePagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [autoUpgradeEnabled, setAutoUpgradeEnabled] = useState(true);
    const [deviceDetailVisible, setDeviceDetailVisible] = useState(false);
    const [currentDevice, setCurrentDevice] = useState(null);
    const [upgradeModalVisible, setUpgradeModalVisible] = useState(false);
    const [selectedVersion, setSelectedVersion] = useState("");

    useEffect(() => {
        loadFirmwareList();
        loadDevices();

        // 设备状态轮询
        const interval = setInterval(() => {
            loadDevices();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    const loadFirmwareList = async (
        pageNum = pagination.current,
        pageSize = pagination.pageSize,
        status = ""
    ) => {
        setLoading(true);
        try {
            const response = await apiService.firmwareUpgrade.getFirmwareUpgrade(pageNum, pageSize, status);

            if (response.code === 200) {
                setPagination({
                    current: response.data.current,
                    pageSize: response.data.size,
                    total: response.data.total,
                    pageCount: response.data.pages
                });

                const validRecords = response.data.records.filter(record =>
                    record && record.id && record.version
                );

                setFirmwareList(validRecords.map(item => ({
                    ...item,
                    key: item.id,
                    size: item.size ? `${(item.size / 1024 / 1024).toFixed(2)} MB` : '0 MB'
                })));
            }
        } catch (error) {
            message.error('获取固件列表失败: ' + (error.message || '未知错误'));
        } finally {
            setLoading(false);
        }
    };

    const loadDevices = async () => {
        try {
            const response = await apiService.firmwareUpgrade.getFirmwareUpgradeRecordList(devicePagination.current, devicePagination.pageSize);

            if (response.code === 200) {
                setDevicePagination({
                    current: response.data.current,
                    pageSize: response.data.size,
                    total: response.data.total
                });

                setDevices(response.data.records.map(device => ({
                    ...device,
                    key: device.id
                })));

                console.log("设备列表", response.data.records);
            }
        } catch (error) {
            message.error('获取设备列表失败: ' + error.message);
        }
    };

    const beforeUpload = (file) => {
        const isFirmware = file.type === 'application/octet-stream' ||
            file.name.endsWith('.bin') ||
            file.name.endsWith('.hex') ||
            file.name.endsWith('.img') ||
            file.name.endsWith('.zip');

        if (!isFirmware) {
            message.error('请上传正确的固件文件格式(.bin, .hex, .img, .zip)');
            return false;
        }

        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isLt100M) {
            message.error('固件文件大小不能超过100MB');
            return false;
        }

        setFileList([file]);
        return false;
    };

    const handleRemove = () => {
        setFileList([]);
        setUploadProgress(0);
        setUploadStatus('');
    };

    const handleUpload = async (values) => {
        if (fileList.length === 0) {
            message.warning('请先选择固件文件');
            return;
        }

        const file = fileList[0];
        setUploading(true);
        setUploadStatus('uploading');
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('version', values.version);
            formData.append('deviceType', values.deviceType);
            formData.append('description', values.description);
            formData.append('name', values.name);
            formData.append('isForceUpgrade', values.isForceUpgrade ? 1 : 0);
            formData.append('releaseChannel', values.releaseChannel);
            formData.append('minCompatibleVersion', values.minCompatibleVersion);
            formData.append('hardwareVersion', values.hardwareVersion);
            formData.append('releaseNotes', values.releaseNotes);

            const response = await apiService.instance.post('/firmware/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(percentCompleted);
                    }
                },
            });

            if (response.code === 200) {
                const firmwareData = response.data;
                const newFirmware = {
                    ...firmwareData,
                    key: firmwareData.id,
                    size: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
                    uploadTime: firmwareData.uploadTime || moment().valueOf()
                };

                setFirmwareList([newFirmware, ...firmwareList]);
                setUploadStatus('success');
                message.success(response.data.message || '固件上传成功');
                handleRemove();
                form.resetFields();

                // 如果是强制升级且自动升级开启，则推送到设备
                if (values.isForceUpgrade && autoUpgradeEnabled) {
                    message.info('开始自动推送升级到所有设备');
                    // 这里调用API推送升级到设备
                    await pushUpgradeToDevices(newFirmware.id, values.deviceType);
                }
            } else {
                throw new Error(response.message || '上传失败');
            }
        } catch (error) {
            setUploadStatus('error');
            if (error.response) {
                message.error('固件上传失败: ' + (error.response.data.message || error.response.statusText));
            } else if (error.request) {
                message.error('固件上传失败: 网络连接错误');
            } else {
                message.error('固件上传失败: ' + (error.message || '未知错误'));
            }
        } finally {
            setUploading(false);
        }
    };

    const pushUpgradeToDevices = async (firmwareId, deviceType) => {
        try {
            const response = await apiService.firmwareUpgrade.pushUpgrade(firmwareId, deviceType);
            if (response.code === 200) {
                message.success('升级任务已推送到设备');
                loadDevices(); // 刷新设备列表
            }
        } catch (error) {
            message.error('推送升级失败: ' + error.message);
        }
    };

    const deleteFirmware = async (id) => {
        try {
            const response = await apiService.firmwareUpgrade.deleteFirmwareUpgrade(id);
            if (response.code === 200) {
                message.success('固件删除成功');
                setFirmwareList(firmwareList.filter(item => item.id !== id));
                setSelectedRowKeys(selectedRowKeys.filter(key => key !== id));
            } else {
                message.error('删除固件失败: ' + (response.message || '未知错误'));
            }
        } catch (error) {
            message.error('删除固件失败: ' + error.message);
        }
    };

    const batchDeleteFirmware = () => {
        if (selectedRowKeys.length === 0) {
            message.warning('请先选择要删除的固件');
            return;
        }

        Modal.confirm({
            title: `确认要删除选中的 ${selectedRowKeys.length} 个固件吗？`,
            content: '此操作不可撤销，请谨慎操作',
            okText: '确认删除',
            okType: 'danger',
            cancelText: '取消',
            onOk: async () => {
                try {
                    const response = await apiService.firmwareUpgrade.batchDeleteFirmwareUpgrade(selectedRowKeys);
                    if (response.code === 200) {
                        message.success(`成功删除 ${selectedRowKeys.length} 个固件`);
                        setFirmwareList(firmwareList.filter(item => !selectedRowKeys.includes(item.id)));
                        setSelectedRowKeys([]);
                        loadFirmwareList();
                    } else {
                        message.error('批量删除失败: ' + (response.message || '未知错误'));
                    }
                } catch (error) {
                    message.error('批量删除失败: ' + error.message);
                }
            }
        });
    };

    const downloadFirmware = async (id) => {
        try {
            const firmware = firmwareList.find(item => item.id === id);
            if (!firmware) {
                message.error('找不到指定的固件');
                return;
            }

            message.loading({content: '准备下载固件...', key: 'download', duration: 0});

            // 构建完整下载URL
            const downloadUrl = apiService.baseURL.replace('/api', '') + firmware.fileUrl;

            // 创建下载链接并触发下载
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', firmware.name || 'firmware');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success({content: '固件下载开始', key: 'download'});
        } catch (error) {
            message.error({content: '下载固件失败: ' + error.message, key: 'download'});
        }
    };

    const showFirmwareModal = (firmware) => {
        setCurrentFirmware(firmware);
        form.setFieldsValue({
            ...firmware,
            uploadTime: moment(firmware.uploadTime)
        });
        setIsModalVisible(true);
    };

    const handleModalOk = async () => {
        try {
            const values = await form.validateFields();
            const updatedFirmware = {
                ...currentFirmware,
                ...values,
            };

            const response = await apiService.firmwareUpgrade.updateFirmwareUpgrade(
                updatedFirmware.id,
                updatedFirmware
            );

            if (response.code === 200) {
                message.success('固件信息更新成功');
                setFirmwareList(firmwareList.map(item =>
                    item.id === updatedFirmware.id ? updatedFirmware : item
                ));
                setIsModalVisible(false);
            } else {
                message.error(response.message || '固件信息更新失败');
            }
        } catch (error) {
            message.error('验证失败: ' + error.message);
        }
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const onTableRowSelection = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
    };

    const handleTableChange = async (pagination, filters, sorter) => {
        await setPagination(pagination);
        await loadFirmwareList(pagination.current, pagination.pageSize);
    };

    const uploadProps = {
        onRemove: handleRemove,
        beforeUpload,
        fileList,
        maxCount: 1,
        accept: '.bin,.hex,.img,.zip,application/octet-stream',
    };

    // 设备管理相关方法
    const openUpgradeModal = () => {
        if (selectedDevices.length === 0) {
            message.warning('请先选择设备');
            return;
        }
        setUpgradeModalVisible(true);
    };

    const executeDevicesUpgrade = async () => {
        if (!selectedVersion) {
            message.warning('请选择目标版本');
            return;
        }

        try {
            const firmware = firmwareList.find(fw => fw.version === selectedVersion);
            if (!firmware) {
                message.error('找不到指定的固件版本');
                return;
            }

            // const response = await apiService.devices.upgradeDevices(selectedDevices, firmware.id);
            // if (response.code === 200) {
            //     message.success(`已成功标记${selectedDevices.length}台设备升级到${selectedVersion}`);
            //     setSelectedDevices([]);
            //     setUpgradeModalVisible(false);
            //     setSelectedVersion("");
            //     loadDevices(); // 刷新设备状态
            // } else {
            //     message.error(response.message || '升级操作失败');
            // }
        } catch (error) {
            message.error('升级操作失败: ' + error.message);
        }
    };

    const cancelDevicesUpgrade = async () => {
        if (selectedDevices.length === 0) {
            message.warning('请先选择设备');
            return;
        }

        try {
            const response = await apiService.devices.cancelUpgrade(selectedDevices);
            if (response.code === 200) {
                message.success(`已取消${selectedDevices.length}台设备的升级任务`);
                setSelectedDevices([]);
                loadDevices(); // 刷新设备状态
            } else {
                message.error(response.message || '取消升级操作失败');
            }
        } catch (error) {
            message.error('取消升级操作失败: ' + error.message);
        }
    };

    const getDeviceStatusTag = (status) => {
        switch (status) {
            // enum('pending', 'in_progress', 'completed', 'failed', 'canceled')
            case 'pending':
                return <Tag icon={<PauseOutlined/>} color="warning">等待升级</Tag>;
            case 'in_progress':
                return <Tag icon={<SyncOutlined spin/>} color="processing">升级进行中</Tag>;
            case 'completed':
                return <Tag icon={<CheckCircleOutlined/>} color="success">升级完成</Tag>;
            case 'failed':
                return <Tag icon={<WarningOutlined/>} color="error">升级失败</Tag>;
            case 'idle':
                return <Tag icon={<CheckCircleOutlined/>} color="default">空闲</Tag>;
            default:
                return <Tag>未知</Tag>;
        }
    };

    const showDeviceDetail = (device) => {
        setCurrentDevice(device);
        setDeviceDetailVisible(true);
    };

    const getAvailableVersions = (device) => {
        return firmwareList
            .filter(fw => fw.deviceType === device.deviceType && fw.status === 'active')
            .filter(fw => fw.version !== device.currentVersion)
            .sort((a, b) => b.version.localeCompare(a.version));
    };

    const autoGenerateVersion = () => {
        const lastVersion = firmwareList[0]?.version || 'v0.0.0';
        const [, major, minor, patch] = lastVersion.match(/v(\d+)\.(\d+)\.(\d+)/) || [];

        form.setFieldsValue({
            version: `v${major}.${minor}.${parseInt(patch) + 1}`,
            minCompatibleVersion: `v${major}.${minor}.0`
        });
    };

    const statusTagRender = (status) => {
        const statusMap = {
            active: {color: 'green', text: '活跃', icon: <CheckCircleOutlined/>},
            beta: {color: 'orange', text: '测试', icon: <WarningOutlined/>},
            deprecated: {color: 'red', text: '废弃', icon: <DeleteOutlined/>},
            pending: {color: 'blue', text: '待发布', icon: <ClockCircleOutlined/>}
        };
        return (
            <Tag color={statusMap[status]?.color || 'default'} icon={statusMap[status]?.icon}>
                {statusMap[status]?.text || status}
            </Tag>
        );
    };

    const releaseChannelTagRender = (channel) => {
        const channelMap = {
            stable: {color: 'green', text: '稳定版'},
            beta: {color: 'orange', text: '测试版'},
            alpha: {color: 'purple', text: '开发版'}
        };
        return (
            <Tag color={channelMap[channel]?.color || 'default'}>
                {channelMap[channel]?.text || channel}
            </Tag>
        );
    };

    // 表格列定义
    const firmwareColumns = [
        {
            title: '固件版本',
            dataIndex: 'version',
            key: 'version',
            fixed: 'left',
            width: 150,
            render: (text, record) => (
                <Space direction="vertical" size={0}>
                    <Text strong style={{fontSize: 14}}>{text}</Text>
                    {record.isForceUpgrade && (
                        <Tag color="red" style={{margin: 0, fontSize: 10, lineHeight: '14px'}}>强制升级</Tag>
                    )}
                </Space>
            )
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            filters: [
                {text: '活跃', value: 'active'},
                {text: '测试', value: 'beta'},
                {text: '废弃', value: 'deprecated'},
                {text: '待发布', value: 'pending'},
            ],
            render: statusTagRender
        },
        {
            title: '渠道',
            dataIndex: 'releaseChannel',
            key: 'releaseChannel',
            width: 100,
            render: releaseChannelTagRender
        },
        {
            title: '固件名称',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            ellipsis: true,
            render: (text) => <Text style={{color: '#1890ff'}}>{text}</Text>
        },
        {
            title: '设备类型',
            dataIndex: 'deviceType',
            key: 'deviceType',
            width: 150,
            render: (text) => <Text type="secondary">{text}</Text>
        },
        {
            title: '硬件版本',
            dataIndex: 'hardwareVersion',
            key: 'hardwareVersion',
            width: 120,
            render: (text) => <Tag color="blue">{text}</Tag>
        },
        {
            title: '文件大小',
            dataIndex: 'size',
            key: 'size',
            width: 100,
            render: (text) => <Text type="secondary">{text}</Text>
        },
        {
            title: '校验和',
            dataIndex: 'checksum',
            key: 'checksum',
            width: 120,
            ellipsis: true,
            render: (text) => <Text code>{text}</Text>
        },
        {
            title: '上传时间',
            dataIndex: 'uploadTime',
            key: 'uploadTime',
            width: 180,
            render: (text) => (
                <div style={{fontSize: 12}}>
                    <div>{moment(text).format('YYYY-MM-DD')}</div>
                    <div style={{color: '#999'}}>{moment(text).format('HH:mm:ss')}</div>
                </div>
            ),
            sorter: (a, b) => a.uploadTime - b.uploadTime
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 180,
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="link"
                        size="small"
                        icon={<EditOutlined/>}
                        onClick={() => showFirmwareModal(record)}
                        style={{color: '#1890ff'}}
                    >
                        编辑
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        icon={<DownloadOutlined/>}
                        onClick={() => downloadFirmware(record.id)}
                        style={{color: '#52c41a'}}
                    >
                        下载
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        icon={<RadarChartOutlined/>}
                        onClick={() => {
                            setCurrentFirmware(record);
                            setActiveTab('devices');
                        }}
                        style={{color: '#722ed1'}}
                    >
                        管理设备
                    </Button>
                    <Popconfirm
                        title="确定要删除这个固件吗？"
                        onConfirm={() => deleteFirmware(record.id)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button type="link" danger size="small" icon={<DeleteOutlined/>}>
                            删除
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const deviceColumns = [
//         createdAt: 1754229146000
// ​​
// deleted: 0
// ​​
// deviceCode: "test"
// ​​
// deviceId: 18
// ​​
// endTime: null
// ​​
// errorMessage: null
// ​​
// firmwareId: 12
// ​​
// fromVersion: "v1.2.0"
// ​​
// id: 1
// ​​
// progress: 0
// ​​
// startTime: null
// ​​
// status: "in_progress"
// ​​
// toVersion: "v1.2.1"
// ​​
// updatedAt: 1754229806000
        {
            title: '设备编码',
            dataIndex: 'deviceCode',
            key: 'deviceCode',
            width: 150,
            render: (text, record) => (
                <Button type="link" onClick={() => showDeviceDetail(record)}>
                    {text}
                </Button>
            )
        },
        {
            title: 'IP地址',
            dataIndex: 'ipAddress',
            key: 'ipAddress',
            width: 120,
            render: (ip) => {
                return (typeof ip === 'string' && ip.trim().length > 0) ? ip : '未知地址'
            }
        },
        {
            title: '当前版本',
            dataIndex: 'fromVersion',
            key: 'fromVersion',
            width: 120,
            render: (text) => <Tag color="blue">{text}</Tag>,
            sorter: (a, b) => a.currentVersion.localeCompare(b.currentVersion)
        },
        {
            title: '目标版本',
            dataIndex: 'toVersion',
            key: 'toVersion',
            width: 150,
            render: (text, record) => (
                <Space>
                    {text ? <Tag color="green">{text}</Tag> : '-'}
                    {!text && getAvailableVersions(record).length > 0 && (
                        <Button
                            size="small"
                            icon={<RocketOutlined/>}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedDevices([record.id]);
                                openUpgradeModal();
                            }}
                        />
                    )}
                </Space>
            ),
            sorter: (a, b) => (a.targetVersion || '').localeCompare(b.targetVersion || '')
        },
        {
            title: '升级状态',
            dataIndex: 'status',
            key: 'status',
            width: 150,
            render: (status, record) => (
                <Space>
                    {getDeviceStatusTag(status)}
                    {status === 'failed' && (
                        <Tooltip title={record.errorMessage}>
                            <InfoCircleOutlined style={{color: 'red'}}/>
                        </Tooltip>
                    )}
                </Space>
            ),
            filters: [
                {text: '空闲', value: 'idle'},
                {text: '等待升级', value: 'pending'},
                {text: '升级中', value: 'in_progress'},
                {text: '升级完成', value: 'completed'},
                {text: '升级失败', value: 'failed'}
            ],
            onFilter: (value, record) => record.status === value
        },
        // {
        //     title: '状态详情',
        //     dataIndex: 'upgradeStatus',
        //     key: 'statusDetail',
        //     width: 150,
        //     render: (status) => {
        //         switch(status) {
        //             case 'upgrading': return '升级中';
        //             case 'pending': return '等待升级';
        //             case 'completed': return '已完成';
        //             default: return '-';
        //         }
        //     }
        // },
        // {
        //     title: '操作',
        //     key: 'action',
        //     width: 120,
        //     render: (_, record) => (
        //         <Space>
        //             {record.upgradeStatus === 'pending' && (
        //                 <Tooltip title="取消升级">
        //                     <Button
        //                         size="small"
        //                         danger
        //                         icon={<PauseOutlined/>}
        //                         onClick={() => {
        //                             setSelectedDevices([record.id]);
        //                             cancelDevicesUpgrade();
        //                         }}
        //                     />
        //                 </Tooltip>
        //             )}
        //             {getAvailableVersions(record).length > 0 && (
        //                 <Tooltip title="升级到...">
        //                     <Button
        //                         size="small"
        //                         type="primary"
        //                         icon={<RocketOutlined/>}
        //                         onClick={() => {
        //                             setSelectedDevices([record.id]);
        //                             openUpgradeModal();
        //                         }}
        //                     />
        //                 </Tooltip>
        //             )}
        //         </Space>
        //     )
        // }
    ];

    const rowSelection = {
        selectedRowKeys,
        onChange: onTableRowSelection,
    };

    return (
        <div className="firmware-management">
            <Card
                title={
                    <Space>
                        <AppstoreOutlined/>
                        <span>固件升级管理</span>
                    </Space>
                }
                extra={
                    <Space>
                        <Switch
                            checkedChildren="自动升级开启"
                            unCheckedChildren="自动升级关闭"
                            checked={autoUpgradeEnabled}
                            onChange={setAutoUpgradeEnabled}
                        />
                        <Button
                            type="primary"
                            onClick={() => setActiveTab('upload')}
                            icon={<CloudUploadOutlined/>}
                        >
                            上传新版本
                        </Button>
                    </Space>
                }
            >
                <Tabs activeKey={activeTab} onChange={setActiveTab}>
                    <TabPane tab="版本列表" key="list">
                        <Table
                            locale={{
                                emptyText: firmwareList.length === 0 ? '暂无数据' : ' '
                            }}
                            dataSource={firmwareList}
                            columns={firmwareColumns}
                            rowKey="id"
                            rowSelection={rowSelection}
                            pagination={{
                                ...pagination,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                pageSizeOptions: ['5', '10', '20', '50'],
                                showTotal: (total) => `共 ${total} 条记录`,
                                style: {marginRight: 16}
                            }}
                            onChange={handleTableChange}
                            scroll={{x: 1500}}
                            bordered={false}
                            style={{border: 'none'}}
                            rowClassName={() => 'firmware-table-row'}
                        />
                    </TabPane>

                    <TabPane tab="版本上传" key="upload">
                        <Form form={form} layout="vertical" onFinish={handleUpload}>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label="版本号"
                                        name="version"
                                        rules={[
                                            {required: true, message: '请输入固件版本!'},
                                            {pattern: /^v\d+\.\d+\.\d+$/, message: '版本格式应为 v1.0.0'}
                                        ]}
                                    >
                                        <Input
                                            placeholder="例如: v1.0.0"
                                            addonBefore={
                                                <Button
                                                    type="text"
                                                    icon={<SyncOutlined/>}
                                                    onClick={autoGenerateVersion}
                                                />
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="设备类型"
                                        name="deviceType"
                                        rules={[{required: true, message: '请选择设备类型!'}]}
                                    >
                                        <Select>
                                            <Option value="Intelligent Color Mixing Machine">Intelligent Color Mixing
                                                Machine</Option>
                                            <Option value="Sensor Module">Sensor Module</Option>
                                            <Option value="Controller Unit">Controller Unit</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                label="固件名称"
                                name="name"
                                rules={[
                                    {required: true, message: '请输入固件名称!'},
                                ]}
                            >
                                <Input placeholder="输入固件名称"/>
                            </Form.Item>

                            <Form.Item
                                label="硬件版本"
                                name="hardwareVersion"
                                rules={[{required: true, message: '请输入硬件版本!'}]}
                            >
                                <Input placeholder="例如: v1.0"/>
                            </Form.Item>

                            <Form.Item
                                label="最低兼容版本"
                                name="minCompatibleVersion"
                                rules={[
                                    {required: true, message: '请输入最低兼容版本!'},
                                    {pattern: /^v\d+\.\d+\.\d+$/, message: '版本格式应为 v1.0.0'}
                                ]}
                            >
                                <Input placeholder="例如: v1.0.0"/>
                            </Form.Item>

                            <Form.Item
                                label="发布渠道"
                                name="releaseChannel"
                                rules={[{required: true, message: '请选择发布渠道!'}]}
                            >
                                <Select>
                                    <Option value="stable">稳定版</Option>
                                    <Option value="beta">测试版</Option>
                                    <Option value="alpha">开发版</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                label="强制升级"
                                name="isForceUpgrade"
                                valuePropName="checked"
                                rules={[
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (getFieldValue('status') === 'deprecated' && value) {
                                                return Promise.reject(new Error('废弃版本不允许设置为强制升级'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Switch checkedChildren="是" unCheckedChildren="否" disabled={!autoUpgradeEnabled}/>
                            </Form.Item>

                            <Form.Item
                                label="固件描述"
                                name="description"
                                rules={[{required: true, message: '请输入固件描述!'}]}
                            >
                                <TextArea rows={3} placeholder="请输入固件描述信息"/>
                            </Form.Item>

                            <Form.Item
                                label="发布说明"
                                name="releaseNotes"
                            >
                                <TextArea rows={3} placeholder="请输入版本更新内容"/>
                            </Form.Item>

                            <Form.Item>
                                <Dragger {...uploadProps} disabled={uploading}>
                                    {uploading ? (
                                        <Progress percent={uploadProgress} status="active"/>
                                    ) : (
                                        <>
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined/>
                                            </p>
                                            <p className="ant-upload-text">点击或拖拽固件文件到此处</p>
                                            <p className="ant-upload-hint">支持.bin/.hex/.img/.zip格式，不超过100MB</p>
                                        </>
                                    )}
                                </Dragger>
                            </Form.Item>

                            <Space>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={uploading}
                                    disabled={fileList.length === 0}
                                >
                                    确认发布
                                </Button>
                                <Button onClick={() => form.resetFields()}>
                                    重置表单
                                </Button>
                            </Space>
                        </Form>
                    </TabPane>

                    <TabPane tab="设备管理" key="devices">
                        <Card
                            title={
                                <Space>
                                    <RadarChartOutlined/>
                                    <span>设备升级管理</span>
                                    {currentFirmware && (
                                        <Tag color="blue">当前固件版本: {currentFirmware.version}</Tag>
                                    )}
                                </Space>
                            }
                            extra={
                                <Space>
                                    <Button
                                        icon={<SyncOutlined/>}
                                        onClick={loadDevices}
                                    >
                                        刷新状态
                                    </Button>
                                    {selectedDevices.length > 0 && (
                                        <Space>
                                            <Popconfirm
                                                title="确定要取消选中设备的升级任务吗？"
                                                onConfirm={cancelDevicesUpgrade}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <Button
                                                    danger
                                                    icon={<PauseOutlined/>}
                                                >
                                                    取消升级
                                                </Button>
                                            </Popconfirm>
                                            <Button
                                                type="primary"
                                                icon={<RocketOutlined/>}
                                                onClick={openUpgradeModal}
                                            >
                                                升级到...
                                            </Button>
                                        </Space>
                                    )}
                                </Space>
                            }
                        >
                            <Table
                                rowSelection={{
                                    selectedRowKeys: selectedDevices,
                                    onChange: setSelectedDevices,
                                    getCheckboxProps: record => ({
                                        disabled: record.upgradeStatus === 'upgrading'
                                    })
                                }}
                                columns={deviceColumns}
                                dataSource={devices.filter(d =>
                                    !currentFirmware || d.deviceType === currentFirmware.deviceType
                                )}
                                rowKey="id"
                                pagination={{
                                    ...devicePagination,
                                    showSizeChanger: true,
                                    onChange: (page, pageSize) => setDevicePagination({
                                        ...devicePagination,
                                        current: page,
                                        pageSize
                                    })
                                }}
                                scroll={{x: 1000}}
                            />
                        </Card>
                    </TabPane>
                </Tabs>
            </Card>

            {/* 固件编辑模态框 */}
            <Modal
                title="编辑固件信息"
                visible={isModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText="确认"
                cancelText="取消"
                width={700}
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        name="version"
                        label="固件版本"
                        rules={[
                            {required: true, message: '请输入固件版本!'},
                            {pattern: /^v\d+\.\d+\.\d+$/, message: '版本格式应为 v1.0.0'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        name="name"
                        label="固件名称"
                        rules={[
                            {required: true, message: '请输入固件名称!'},
                        ]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        name="deviceType"
                        label="设备类型"
                        rules={[{required: true, message: '请选择设备类型!'}]}
                    >
                        <Select>
                            <Option value="Intelligent Color Mixing Machine">Intelligent Color Mixing Machine</Option>
                            <Option value="Sensor Module">Sensor Module</Option>
                            <Option value="Controller Unit">Controller Unit</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="hardwareVersion"
                        label="硬件版本"
                        rules={[{required: true, message: '请输入硬件版本!'}]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        name="minCompatibleVersion"
                        label="最低兼容版本"
                        rules={[
                            {required: true, message: '请输入最低兼容版本!'},
                            {pattern: /^v\d+\.\d+\.\d+$/, message: '版本格式应为 v1.0.0'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        name="releaseChannel"
                        label="发布渠道"
                        rules={[{required: true, message: '请选择发布渠道!'}]}
                    >
                        <Select>
                            <Option value="stable">稳定版</Option>
                            <Option value="beta">测试版</Option>
                            <Option value="alpha">开发版</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="status"
                        label="状态"
                        rules={[{required: true, message: '请选择状态!'}]}
                    >
                        <Select>
                            <Option value="active">活跃</Option>
                            <Option value="beta">测试</Option>
                            <Option value="deprecated">废弃</Option>
                            <Option value="pending">待发布</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="isForceUpgrade"
                        label="强制升级"
                        valuePropName="checked"
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (getFieldValue('status') === 'deprecated' && value) {
                                        return Promise.reject(new Error('废弃版本不允许设置为强制升级'));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Switch checkedChildren="是" unCheckedChildren="否"/>
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="固件描述"
                        rules={[{required: true, message: '请输入固件描述!'}]}
                    >
                        <TextArea rows={3}/>
                    </Form.Item>

                    <Form.Item
                        name="releaseNotes"
                        label="发布说明"
                    >
                        <TextArea rows={3}/>
                    </Form.Item>

                    <Form.Item
                        name="uploadTime"
                        label="上传时间"
                    >
                        <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{width: '100%'}}/>
                    </Form.Item>
                </Form>
            </Modal>

            {/* 设备详情抽屉 */}
            <Drawer
                title="设备详情"
                width={600}
                visible={deviceDetailVisible}
                onClose={() => setDeviceDetailVisible(false)}
            >
                {currentDevice && (
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="设备ID">{currentDevice.id}</Descriptions.Item>
                        <Descriptions.Item label="设备名称">{currentDevice.deviceCode}</Descriptions.Item>
                        <Descriptions.Item label="IP地址">{currentDevice.ipAddress || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="设备类型">{currentDevice.deviceType}</Descriptions.Item>
                        <Descriptions.Item label="当前版本">
                            <Tag color="blue">{currentDevice.fromVersion}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="升级状态">
                            {getDeviceStatusTag(currentDevice.upgradeStatus)}
                        </Descriptions.Item>
                        {currentDevice.upgradeStatus === 'upgrading' && (
                            <Descriptions.Item label="升级进度">
                                <Progress percent={currentDevice.progress} status="active"/>
                            </Descriptions.Item>
                        )}
                        {currentDevice.targetVersion && (
                            <Descriptions.Item label="目标版本">
                                <Tag color="green">{currentDevice.toVersion}</Tag>
                            </Descriptions.Item>
                        )}
                        <Descriptions.Item label="最后活跃时间">
                            {moment(currentDevice.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
                        </Descriptions.Item>
                        <Descriptions.Item label="最后升级时间">
                            {currentDevice.updatedAt ?
                                moment(currentDevice.updatedAt).format('YYYY-MM-DD HH:mm:ss') :
                                '无记录'}
                        </Descriptions.Item>
                    </Descriptions>
                )}
            </Drawer>

            {/* 升级版本选择模态框 */}
            <Modal
                title="选择升级版本"
                visible={upgradeModalVisible}
                onOk={executeDevicesUpgrade}
                onCancel={() => {
                    setUpgradeModalVisible(false);
                    setSelectedVersion("");
                }}
                okText="确认升级"
                cancelText="取消"
            >
                <Form layout="vertical">
                    <Form.Item label="选择目标版本" required>
                        <Select
                            placeholder="请选择版本"
                            value={selectedVersion}
                            onChange={setSelectedVersion}
                        >
                            {firmwareList
                                .filter(fw => !currentFirmware || fw.deviceType === currentFirmware.deviceType)
                                .filter(fw => fw.status === 'active')
                                .sort((a, b) => b.version.localeCompare(a.version))
                                .map(fw => (
                                    <Option key={fw.id} value={fw.version}>
                                        {fw.version} ({fw.deviceType})
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="将升级以下设备">
                        <List
                            size="small"
                            dataSource={devices.filter(d => selectedDevices.includes(d.id))}
                            renderItem={device => (
                                <List.Item>
                                    {device.name} (当前: {device.currentVersion})
                                </List.Item>
                            )}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default FirmwareManagement;